import React from 'react'
import debounce from 'lodash/debounce'
import { SiteContainer, Main, Flex, FlexItem, Wrapper } from 'core/layout'
import { Heading, Card, Hairline, Anchor, Link, BreadcrumbsConnected } from 'elements'
import { RawContent } from 'elements/util'
import flattenDeep from 'lodash/flattenDeep'
import deburr from 'lodash/deburr'
import orderBy from 'lodash/orderBy'
import tulkojumi from 'utils/tulkojumi';
import pathWithRewrite from 'utils/pathWithRewrite';
import { LetterNav,LinkList,LinkItem } from './styled';



var jump;
if (__isBrowser__) { // eslint-disable-line no-undef
  import('jump.js')
  .then((jumpModule) => {
    jump = jumpModule.default;
  })
}

let alphabet = {
  lv: {
    'A': false,
    'B': false,
    'C': false,
    'D': false,
    'E': false,
    'F': false,
    'G': false,
    'H': false,
    'I': false,
    'J': false,
    'K': false,
    'L': false,
    'M': false,
    'N': false,
    'O': false,
    'P': false,
    'R': false,
    'S': false,
    'T': false,
    'U': false,
    'V': false,
    'Z': false
  },
  en: {
    'A':false,
    'B':false,
    'C':false,
    'D':false,
    'E':false,
    'F':false,
    'G':false,
    'H':false,
    'I':false,
    'J':false,
    'K':false,
    'L':false,
    'M':false,
    'N':false,
    'O':false,
    'P':false,
    'Q':false,
    'R':false,
    'S':false,
    'T':false,
    'U':false,
    'V':false,
    'W':false,
    'X':false,
    'Y':false,
    'Z':false
  },
  ru: {
    'А': false,
    'Б': false,
    'В': false,
    'Г': false,
    'Д': false,
    'E': false,
    'Ё': false,
    'Ж': false,
    'З': false,
    'И': false,
    'Й': false,
    'К': false,
    'Л': false,
    'М': false,
    'Н': false,
    'O': false,
    'П': false,
    'Р': false,
    'С': false,
    'Т': false,
    'У': false,
    'Ф': false,
    'Х': false,
    'Ц': false,
    'Ч': false,
    'Ш': false,
    'Щ': false,
    'Ъ': false,
    'Ы': false,
    'Ь': false,
    'Э': false,
    'Ю': false,
    'Я': false
  }
}
// const alphabet = ['A', 'Ā', 'B', 'C', 'Č', 'D', 'E', 'Ē', 'F', 'G', 'Ģ', 'H', 'I', 'Ī', 'J', 'K', 'Ķ', 'L', 'Ļ', 'M', 'N', 'Ņ', 'O', 'P', 'R', 'S', 'Š', 'T', 'U', 'Ū', 'V', 'Z', 'Ž']




class Pakalpojumi extends React.PureComponent {

constructor( props, contex ){
    super(props,contex);
    this._onScroll = this._onScroll.bind(this);
    this._handleResize = debounce(this._onResize, 200);
    this.state = {
       active:'',
      scrollTop:0,
      fixed:false,
      direction:'down'
    };
  }


  // state = {
  //   active:'',
  //   scrollTop:0,
  //   direction:'down'
  // }

  componentDidMount(){
    window.removeEventListener('scroll', this._onScroll);
    window.addEventListener('scroll', this._onScroll, false);

    window.addEventListener('resize', this._handleResize);
    this._onResize(null);
  }

  componentWillUnmount(){
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._handleResize);
  }


  _onResize = (event) => {
    this._fixedHeight = this._calculateFixedHeight();
    this.forceUpdate();
  }

  _calculateFixedHeight = () => {
    let fixedHeight = 0;

    const target = document.body;

    /* const cookieInfo = target.querySelector('[data-query-id="js-cookie-info"]');
    if (cookieInfo) {
      const cookieInfoRect = cookieInfo.getBoundingClientRect();
      fixedHeight += cookieInfoRect.height;
    } */

    /* if (this._letterNav) {
      const letterNavRect = this._letterNav.getBoundingClientRect();
      fixedHeight += letterNavRect.height;
    } */

    const header = target.querySelector('[data-query-id="js-header"]');
    if (header) {
      const headerRect = header.getBoundingClientRect();
      fixedHeight += headerRect.height;
    }

    return fixedHeight;
  }


  _onScroll( event ){
    let scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

    // var scrollTop = $(window).scrollTop();
    let direction;

    if( this.state.scrollTop < scrollTop) {
        direction = 'down';
        // console.log('down: '+scrollTop);
    } else {
        direction = 'up';
        // console.log('up: '+scrollTop);
    }

    if( this.state.direction !== direction) {
        // console.log('CHANGE DIRECTION:'+direction);
    }

    let update = false

    if(this.state.fixed!==scrollTop>this._fixedHeight){
      update = true
    }

    if(update){
       this.setState(Object.assign(this.state, {
          // scrollTop: scrollTop,
          // direction: direction,
          fixed:scrollTop>this._fixedHeight
      }), () => {
        this._onResize(null);
        this.forceUpdate();
      });
    }



    // if(this.state.direction==='down'&&this.state.scrollTop>94)  {
    //       dispatch(openMobileMenu(false));
    // }
  }

  _renderLevel(sitemap, level, parent_id, type) {

    if (sitemap && sitemap[0]) {
      let filtered = sitemap.filter(page => page && page.title !== '')
      return filtered.length ? (
        filtered.map((page, index) => {
          let last = true
          if (page.relationship_pages && page.relationship_pages[0]) {
            last = false
          }
          if (last) {
            return {
              path: page.path,
              title: page.title,
              slug: deburr(page.title),
              rewrite_url: page.rewrite_url,
              rewrite_target: page.rewrite_target,
              rewrite_source: page.rewrite_source,
            }
          } else {
            return page.relationship_pages && page.relationship_pages[0] ?
              this._renderLevel(page.relationship_pages, page.level + 1, page._id)
              : null
          }
        })
        ) : null
    } else {
      return null
    }

  }

  _jump(event,letter){
    event.preventDefault();

    let jumpOffset = this._fixedHeight;
    const letterNavRect = this._letterNav.getBoundingClientRect();
    jumpOffset += letterNavRect.height + 10;

    jump && jump('#'+letter, {
      duration: 250,
      offset: -jumpOffset,
      a11y: true,
    });

    this.setState(prevState => Object.assign({}, prevState, {
           active: letter
    }));
  }

  _getPathRewriteProps = (page) => {
    const rewrite = pathWithRewrite(page);
    return {
      to: rewrite.location,
      target: rewrite.target,
    };
  }

  render() {

    const props = this.props
    const lang = this.props.lang

    let saraksts = orderBy(flattenDeep(this._renderLevel(props.sitemap, 0, 0)), ['slug'], ['asc']).filter(page => page && page.title !== '')
    let last_char


    let alfabets = saraksts.map((page, index) => {
      if(page){
        if (deburr(page.title.charAt(0)).toUpperCase() !== last_char) {
          last_char = deburr(page.title.charAt(0)).toUpperCase()
          alphabet[lang][last_char] = true
        }
      }

    })


    last_char = ''


    const fixedTopStyle = {
      top: `${this._fixedHeight}px`,
    };


    return (<div>
                    {this.state.fixed ? <LetterNav innerRef={c => this._letterNav = c} className={(this.state.fixed ? 'fixed' : '')} style={fixedTopStyle}>

                      <SiteContainer>
                      <Wrapper>
                      <Flex>
                      <Main>

                      {
                        __isBrowser__ && Object.entries(alphabet[lang]).map((char,index)=>{
                          return <a onClick={(event) => this._jump(event,char[0])} href={`#${char[0]}`} to={{
                                            // pathname: '/courses',
                                            // search: '?sort=name',
                                            hash: '#'+char[0],
                                            state: { active: char[0] }
                                          }} key={index} className={char[1]?(this.state.active===char[0]?'active':''):'disabled'}>{char[0]}</a>
                        })
                      }
                      </Main>
                      </Flex>
                      </Wrapper>
                      </SiteContainer>

                    </LetterNav>:null}


              <SiteContainer>
              <BreadcrumbsConnected lang={ this.props.lang } path={ this.props.path } />
              <Wrapper>
                <Flex>
                  <Main>
                    <Heading>
                      { props.init_page.title }
                    </Heading>

                    <LetterNav innerRef={c => this._letterNav = c}>
                      <div className='LetterNav'>
                      {
                        __isBrowser__ && Object.entries(alphabet[lang]).map((char,index)=>{
                          return <a onClick={(event) => this._jump(event,char[0])} href={`#${char[0]}`} to={{
                                            // pathname: '/courses',
                                            // search: '?sort=name',
                                            hash: '#'+char[0],
                                            state: { active: char[0] }
                                          }} key={index} className={char[1]?(this.state.active===char[0]?'active':''):'disabled'}>{char[0]}</a>
                        })
                      }
                      </div>
                    </LetterNav>



                    <LinkList>
                      { saraksts && saraksts.map((page, index) => {

                          let render_char = false
                          if(page){
                            if (deburr(page.title.charAt(0)).toUpperCase() !== last_char) {
                              last_char = deburr(page.title.charAt(0)).toUpperCase()
                              render_char = true
                            }
                          }

                          return (
                            <LinkItem key={ index }>
                              { render_char ? <a name={last_char} id={last_char}><h1>{ last_char }</h1></a> : null }


                              <Link {...this._getPathRewriteProps(page)} >
                                { page.title }
                              </Link>


                            </LinkItem>
                          )

                        }) }
                    </LinkList>
                  </Main>
                </Flex>
              </Wrapper>
            </SiteContainer></div>)


  }
}

export default Pakalpojumi



// WEBPACK FOOTER //
// ./src/pages/Pakalpojumi/Pakalpojumi.jsx